<template>
  <div class="list">

    <!-- lets display the data -->
    <table class="table">
      <thead>
        <tr>
          <th 
            v-if="display_column( 'Symbol' )"
            scope="col"
          >Symbol</th>
          <th 
            v-if="display_column( 'Name' )"
            scope="col"
          >Name</th>
          <th 
            v-if="display_column( 'Price' )"
            scope="col"
          >Price</th>
          <th 
            v-if="display_column( 'Sector' )"
            scope="col"
          >Sector</th>
          <th 
            v-if="display_column( '52 Week High' )"
            scope="col"
          >52 Week High</th>
          <th 
            v-if="display_column( '52 Week Low' )"
            scope="col"
          >52 Week Low</th>
          <th 
            v-if="display_column( 'Dividend Yield' )"
            scope="col"
          >Dividend Yield</th>
          <th 
            v-if="display_column( 'EBITDA' )"
            scope="col"
          >EBITDA</th>
          <th 
            v-if="display_column( 'Earnings/Share' )"
            scope="col"
          >Earnings/Share</th>
          <th 
            v-if="display_column( 'Market Cap' )"
            scope="col"
          >Market Cap</th>
          <th 
            v-if="display_column( 'Price/Book' )"
            scope="col"
          >Price/Book</th>
          <th 
            v-if="display_column( 'Price/Earnings' )"
            scope="col"
          >Price/Earnings</th>
          <th 
            v-if="display_column( 'Price/Sales' )"
            scope="col"
          >Price/Sales</th>
          <th 
            v-if="display_column( 'SEC Filings' )"
            scope="col"
          >SEC Filings</th>        

        </tr>
      </thead>

      <tbody>
        <tr v-for="company in companies" :key="company.Symbol">
          <td
            v-if="display_column( 'Symbol' )"
          >{{ company.Symbol }}</td>
          <td
            v-if="display_column( 'Name' )"
          >{{ company.Name }}</td>
          <td
            v-if="display_column( 'Price' )"
          >{{ company.Price }}</td>
          <td
            v-if="display_column( 'Sector' )"
          >{{ company.Sector }}</td>
          <td
            v-if="display_column( '52 Week High' )"
          >{{ company['52 Week High'] }}</td>
          <td
            v-if="display_column( '52 Week Low' )"
          >{{ company['52 Week Low'] }}</td>
          <td
            v-if="display_column( 'Dividend Yield' )"
          >{{ company['Dividend Yield'] }}</td>
          <td
            v-if="display_column( 'EBITDA' )"
          >{{ company.EBITDA }}</td>
          <td
            v-if="display_column( 'Earnings/Share' )"
          >{{ company['Earnings/Share'] }}</td>
          <td
            v-if="display_column( 'Market Cap' )"
          >{{ company['Market Cap'] }}</td>
          <td
            v-if="display_column( 'Price/Book' )"
          >{{ company['Price/Book'] }}</td>
          <td
            v-if="display_column( 'Price/Earnings' )"
          >{{ company['Price/Earnings'] }}</td>
          <td
            v-if="display_column( 'Price/Sales' )"
          >{{ company['Price/Sales'] }}</td>
          <td
            v-if="display_column( 'SEC Filings' )"
          ><a :href="company['SEC Filings']">More info...</a></td>
          
        </tr>
      </tbody>
    </table>
    
  </div>
</template>

<script>
export default {
  name: 'ListOfCompanies',
  props: {
    companies: Array,
    columns: Array
  },
  methods: {

    display_column( column ) {

      if( this.columns.includes( column ) ) {

        return true

      }

      return false

    }

  }
}
</script>

<style scoped>

</style>
